/* Packages */
import $ from 'jquery';
import Flickity from 'flickity';
import imagesLoaded from 'imagesloaded';

import 'flickity-as-nav-for';
import 'flickity-bg-lazyload';
import 'flickity-imagesloaded';

/* Constants */
import {IS_DESKTOP} from '../constants';

/* Custom classes */
import CarouselScale from '../custom/carouselScale';

export let defaultCarouselOptions = {
	arrowShape:
		'M23.66 55.744l41.046 41.775a8.129 8.129 0 0011.407-.215c3.126-3.176 3.22-8.296.21-11.587L41.077 49.852l35.248-35.807c3.224-3.259 3.236-8.556.028-11.83a8.144 8.144 0 00-11.646-.029L23.66 43.961a8.38 8.38 0 00-2.41 5.891 8.38 8.38 0 002.41 5.892z',
	cellSelector: '.carousel__slide',
	imagesLoaded: true,
};

export const setDataAttributes = (element, attributes) => {
	for (var key in attributes) {
		element.setAttribute(key, attributes[key]);
	}
};

$('.carousel').each(function () {
	const carousel = $(this),
		carouselOptions = {
			...defaultCarouselOptions,
		};

	// Thumb carousels
	if (carousel.is('[data-flickity-as-nav-for]')) {
		$.extend(true, carouselOptions, {
			asNavFor: carousel.data('flickity-as-nav-for'),
			contain: true,
			pageDots: false,
			prevNextButtons: false,
		});
	}

	// USP carousel
	if (carousel.hasClass('carousel--usps')) {
		$.extend(true, carouselOptions, {
			wrapAround: true,
			watchCSS: true,
			pageDots: false,
			prevNextButtons: false,
		});
	}

	if (carousel.hasClass('carousel--wrap-around')) {
		$.extend(true, carouselOptions, {
			wrapAround: true,
			cellAlign: 'center',
		});
	}

	// Products wizard carousel
	if (carousel.hasClass('carousel--products-wizard')) {
		$.extend(true, carouselOptions, {
			watchCSS: true,
		});
	}

	if (carousel.hasClass('carousel--autoplay')) {
		$.extend(true, carouselOptions, {
			autoPlay: 2500,
		});
	}

	if (carousel.hasClass('carousel--logo-grid')) {
		$.extend(true, carouselOptions, {
			wrapAround: true,
			cellAlign: 'center',
			pageDots: false,
			groupCells: IS_DESKTOP ? 6 : 2,
			percentagePosition: true,
		});
    }
    
    if (carousel.hasClass('carousel--sticky')) {
		$.extend(true, carouselOptions, {
            pageDots: false,
            prevNextButtons: false,
		});
	}

	// Instantiate
	const flkty = new Flickity(this, carouselOptions);

	if (flkty) {
		const prevBtn = flkty.prevButton?.element;
		const nextBtn = flkty.nextButton?.element;

		if (prevBtn && nextBtn) {
			setDataAttributes(prevBtn, {'data-click': true, 'data-type': 'carousel', 'data-content': 'click-previous'});
			setDataAttributes(nextBtn, {'data-click': true, 'data-type': 'carousel', 'data-content': 'click-next'});
		}
	}

	if (carousel.hasClass('carousel--scale')) {
		new CarouselScale(flkty, this);
    }
    
    if (carousel.hasClass('carousel--sticky')) {
		const prevBtn = carousel.parent().find('.pane__carousel-btn-previous');
        const nextBtn = carousel.parent().find('.pane__carousel-btn-next');

        if (prevBtn && nextBtn) {
            prevBtn.on('click', () => {
                flkty.previous(true);
            });
    
            nextBtn.on('click', () => {
                flkty.next(true);
            });
        }
	}

	if (carousel.hasClass('carousel--has-caption')) {
		if (IS_DESKTOP || carousel.hasClass('carousel--sticky')) return;

		flkty.options.adaptiveHeight = true;
		const pageDots = flkty.pageDots.holder;
		const selectedImage = flkty.cells[flkty.selectedIndex].element.querySelector('img');

		const imgLoaded = imagesLoaded(selectedImage);
		imgLoaded.on('always', () => {
			const {size, element} = flkty.cells[0];
			const captionHeight = element.querySelector('.carousel__caption')?.getBoundingClientRect().height || 0;
			const pageDotsHeight = 3;
			const paddingTop = 20;
			const height = size.height - captionHeight;

			pageDots.style.top = `${height + pageDotsHeight + paddingTop}px`;
			pageDots.style.bottom = 'auto';
		});
	}

	if (carousel.hasClass('carousel--with-viewport-check')) {
		const outsideViewportClassname = 'has-reached-outside-viewport';
		let currentProgress = -1;

		flkty.on('scroll', (event, progress) => {
			// Prevent forEach when progress did not change.
			// That is because whenever you hold the slider, the `scroll` event will still be executed every frame
			// even when there is no need to continuously loop over all the slides.
			if (Math.round(currentProgress) !== Math.round(progress)) {
				const viewportX = flkty.viewport.getBoundingClientRect().x;
				const viewportWidth = flkty.viewport.offsetWidth;

				flkty.cells.forEach((cell) => {
					const cellX = cell.element.getBoundingClientRect().x - viewportX;
					// In case the X position of the cell is negative or the cell's X position + width is bigger than the viewport's width
					// then the cell is (partly) outside the slider's viewport
					if (cellX < 0 || viewportWidth - (cellX + cell.size.innerWidth) < 0) {
						cell.element.classList.add(outsideViewportClassname);
					} else {
						cell.element.classList.remove(outsideViewportClassname);
					}
				});
			}

			currentProgress = progress;
		});
	}
});
